import { useEffect, useState } from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { useDialogs } from "@/lib/dialogs";
import { fetchPlans } from "@/lib/platformClient";
import { formatMoney } from "@/config/plans";
import { ACTIVE_COUNTRY } from "@/config/regions";

export const Pricing = () => {
  const { t } = useI18n();
  const open = useDialogs();
  const [annual, setAnnual] = useState(false);
  const [state, setState] = useState({ status: "loading", plans: [], mode: "demo" });

  useEffect(() => {
    fetchPlans()
      .then((r) => setState({ status: "ready", plans: r.plans, mode: r.mode }))
      .catch(() => setState({ status: "error", plans: [], mode: "demo" }));
  }, []);

  const price = (p) => {
    const v = annual ? p.annual : p.monthly;
    return v == null ? "Custom" : <>{formatMoney(v, ACTIVE_COUNTRY.currency, ACTIVE_COUNTRY.numberLocale)} <small>/mo</small></>;
  };

  return (
    <section className="panel" data-testid="pricing-section">
      <div className="price-top">
        <h2 className="panel-title" style={{ margin: 0 }}>{t("pricing_title")}</h2>
        <div className="billing" role="group" aria-label="Billing period">
          <button className={!annual ? "active" : ""} aria-pressed={!annual} onClick={() => setAnnual(false)} data-testid="billing-monthly-button">{t("monthly")}</button>
          <button className={annual ? "active" : ""} aria-pressed={annual} onClick={() => setAnnual(true)} data-testid="billing-annual-button">{t("annual")}</button>
        </div>
      </div>
      {state.mode === "demo" && <span className="tag goldtag" style={{ marginBottom: 10 }} data-testid="pricing-illustrative-tag">ILLUSTRATIVE · NOT A LIVE TARIFF · PLATFORM CONFIG NOT CONNECTED</span>}
      {state.status === "loading" && <p className="fineprint" data-testid="pricing-loading">Loading plans…</p>}
      {state.status === "error" && <div className="notice warn" data-testid="pricing-error">Plans could not be loaded from the platform. Please try again later.</div>}
      {state.status === "ready" && state.plans.length === 0 && <p className="fineprint" data-testid="pricing-empty">No plans are currently published.</p>}
      <div className="plans">
        {state.plans.map((p) => (
          <div key={p.code} className={`price-card ${p.featured ? "featured" : ""}`} data-testid={`plan-card-${p.code.toLowerCase()}`}>
            {p.featured && <span className="tag goldtag popular">Popular</span>}
            <div className="price-title">{p.name}</div>
            <div className="desc">{p.desc}</div>
            <div className="price" data-testid={`plan-price-${p.code.toLowerCase()}`}>{price(p)}</div>
            <ul>{p.features.map((f) => <li key={f}>{f}</li>)}</ul>
            <button className={`btn ${p.featured ? "gold" : "blue"}`} onClick={() => open("onboard", { plan: p.code, billing: annual ? "annual" : "monthly" })} data-testid={`plan-select-${p.code.toLowerCase()}-button`}>
              {p.cta}
            </button>
          </div>
        ))}
      </div>
      <p className="fineprint" style={{ margin: "11px 0 0" }}>* Features rely on the existing Event Management platform and its entitlement checks. Illustrative pricing only; not an active commercial offer. Taxes: {ACTIVE_COUNTRY.taxNote}. No payment is collected on this portal.</p>
    </section>
  );
};
